import { destDetailAtom } from '@/commons/constants';
import { Card, Slide, Typography } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import { isEmptyString } from '@/commons/utils';
import * as _ from 'lodash';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { shippingTargetDetail } from '@/interfaces/plan/shipping';

const MainWrap = styled(Card)<{ $show: boolean }>`
  position: absolute;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: column;
  gap: 1rem;
  top: 4rem;
  right:1rem;
  width: 30rem;
  height: calc(52% - 2rem);
  opacity: 95%;
  .shead{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding-bottom: 8px;
    border-bottom: 1px solid #dfdfdf;
  }
  padding: 1rem;
  overflow:hidden;
  .list {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

export default function DestDetailPop() {
  const { data } = useAtomValue(shippingTargetDetail);
  const [destDetail, setDestDetail] = useAtom(destDetailAtom);

  const [slideIn, setSlideIn] = useState<boolean>();
  const [show, setShow] = useState<boolean>();

  const [orderList, setOrderList] = useState<any[]>();

  useEffect(() => {
    setSlideIn(destDetail ? true : false);
    setShow(destDetail ? true : false);
    if (destDetail) {
      const temp: any[] = [];
      _.forEach(destDetail.dest.orderInfo, (v) => {
        const orderInfo = _.find(data.orderList, ['order_sheet_id', v]);
        if (!orderInfo) return;
        const target = _.filter(data.orderList, ['scan_code', orderInfo.scan_code]);
        temp.push({
          ...orderInfo,
          target,
        });
      });
      setOrderList(temp);
    }
  }, [destDetail]);

  const handleClose = () => {
    setSlideIn(false);
    setTimeout(() => setDestDetail(undefined), 600);
  };

  return (
    <Slide direction="left" in={slideIn}>
      <MainWrap $show={show} elevation={10}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <LocalShippingIcon fontSize="large" sx={{ color: destDetail?.color }} />
            <Typography variant="h5">{destDetail?.car.name}</Typography>
          </div>
          <CloseIcon onClick={handleClose} />
        </div>
        <div className="shead">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span
              style={{
                borderRadius: '25px',
                background: destDetail.color,
                color: '#ffffff',
                width: '1.5rem',
                height: '1.5rem',
                textAlign: 'center',
                fontSize: '1rem',
              }}
            >
              {destDetail.dest.delivery_no}
            </span>
            <Typography variant="h6">{destDetail.dest.name}</Typography>
          </div>
        </div>
        <Typography variant="subtitle1" sx={{ borderBottom: '1px dashed #777777' }}>
          {destDetail.dest.address}
          <br />
          도착예정시간 : {destDetail.dest.arrivalTime}
        </Typography>

        <div className="list">
          {orderList &&
            orderList.length > 0 &&
            orderList.map((aItem: any, index: number) => {
              return (
                <div key={index} style={{ borderBottom: '1.5px solid #444444' }}>
                  <Typography variant="body1" key={index} sx={{ padding: '0.25rem' }}>
                    주문번호 : {aItem.scan_code}
                  </Typography>
                  {aItem.target.map(
                    (tItem: any, tIndex: number) =>
                      isEmptyString(tItem.product_name) && (
                        <Typography variant="body1" key={tIndex} sx={{ padding: '0.25rem' }}>
                          {tIndex + 1}) {tItem.product_name} / 수량 : {tItem.amount}
                        </Typography>
                      ),
                  )}
                </div>
              );
            })}
        </div>
      </MainWrap>
    </Slide>
  );
}
